export const environment = {
	production: true,
	url: 'https://api.qa.carrier.kosaas-mmi.com:3001'
};
